import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { preMatchesRouteI18n } from '../i18n/pre-matches-route-i18n';

export function preMatchesRoutePath(config?: TranslationConfig): string {
  return `/${langRouteI18n(config)}/${preMatchesRouteI18n(config)}`;
}
